<template>
  <div class="wrapper">
    <Header></Header>
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { BankMixins } from "@/mixins/BankService.js";
import api from "@/services/index.js";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

export default {
  name: "App",
  data() {
    return {
      Prefix: [],
    };
  },
  components: { Header, Footer },
  computed: {
    ...mapGetters(["getAppId", "getError", "getLoading", "getLineId"]),
  },
  methods: {
    ...mapMutations([
      "setAlertMessage",
      "setAlertImage",
      "setLogoUrl",
      "setAppId",
      "setLineId",
      "setPhotoCashback",
      "setPhotoAffiliate",
      "setPrefix"
    ]),
    async setFavicons(favImg) {
      let headTitle = document.querySelector("head");
      let setFavicon = document.createElement("link");
      setFavicon.setAttribute("rel", "shortcut icon");
      setFavicon.setAttribute("href", favImg);
      headTitle.appendChild(setFavicon);
    },
    async InitConfig() {
      this.setAppId(this.Prefix.appId);
      this.setPhotoCashback(this.Prefix.cashBack.Image || null);
      this.setPhotoAffiliate(this.Prefix.Affiliate.Image || null);
      this.setAppId(this.Prefix.appId);
      this.setLineId(this.Prefix.LineId);
      this.setLogoUrl(this.Prefix.logoUrl);
      this.setFavicons(this.Prefix.logoUrl);
      this.setAlertImage(this.Prefix.alertyImage);
      this.setAlertMessage(this.Prefix.alertyMessage);
      document
        .querySelector('meta[name="description"]')
        .setAttribute("content", `${this.getAppId} - เว็บไซต์อันดับ 1 ในไทย`);
      document
        .querySelector('meta[name="og:title"]')
        .setAttribute("content", `${this.getAppId} - เว็บไซต์อันดับ 1 ในไทย`);
      document
        .querySelector('meta[name="og:description"]')
        .setAttribute("content", `${this.getAppId} - เว็บไซต์อันดับ 1 ในไทย`);
      document
        .querySelector('meta[name="og:image"]')
        .setAttribute("content", this.Prefix.logoUrl);
      document.documentElement.setAttribute(
        "class",
        `${this.Prefix.theme}-theme`
      );
      document.documentElement.setAttribute("lang", `th`);
      document.title = `${this.getAppId} - เว็บไซต์อันดับ 1 ในไทย`;
    },
  },
  async beforeCreate() {
    await api.get("/v2/prefix?n4").then((v) => {
      if (v.success == true) {
        this.Prefix = v.data;
        this.setPrefix(this.Prefix);
        this.InitConfig();
      } else {
      }
    });
  },
};
</script>

<style>
.register {
  font-family: "db helvethaicamon x" !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/App.vue